import { render, staticRenderFns } from "./AssignAssembly.vue?vue&type=template&id=7353f00e&"
import script from "./AssignAssembly.vue?vue&type=script&lang=js&"
export * from "./AssignAssembly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports